// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"313":"40d56004","416":"550b6da5","471":"f8a2d073","479":"c550ba71","896":"db362edb","938":"78cc1a1f"}[chunkId] + ".chunk.js";
};